import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Box, Grid, Paper, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppButton from "../../../../components/CustomButtons/AppButton";
import { makeStyles } from "@material-ui/core/styles";
import { Rating } from "@material-ui/lab";
import { Link } from "react-router-dom";
import { WORKER_TYPE } from "../../../../config/AppConfig";
import { useSelector } from "react-redux";
import { getAccreditations } from "../../../../store/slices/worker";
import AppColor from 'utilities/AppColor';
import moment from 'moment';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { useMedia } from 'react-use';
import AppUtil from 'utilities/AppUtil';
// import AppTableMobile from 'views/Admin/Component/Table/AppTableMobile';
// import { Col, Container, Row } from 'reactstrap';


const SearchList = props => {
    const {
        totalElements,
        address,
        data,
    } = props;


    const { t } = useTranslation();
    const accreditationList = useSelector(getAccreditations);
    const [accreditations, setAccreditations] = useState([]);
    const below959 = useMedia('(max-width: 1200px)');
    const isMobile = AppUtil.mobileAndTabletCheck();
    const useStyles = makeStyles(() => ({
        resultTitle: {
            textStyle: 'italic',
            fontSize: '15px'
        },
        image: {
            width: '140px',
            height: '140px',
            borderRadius: '70px',
            objectFit: 'cover'
        },
        imageMobile: {
            width: '100px',
            height: '100px',
            borderRadius: '70px',
            objectFit: 'cover'
        },
        title: {
            fontSize: '28px',
            marginBottom: '20px'
        },
        titleMobile: {
            marginTop: '20px',
            marginBottom: '10px',
            fontSize: '18px',
            textAlign: 'center',
        },
        specialty: {
            fontSize: '14px',
            fontWeight: 'bold'
        },
        container: {
            borderBottom: '1px solid rgba(0, 0, 0, 0.18)'
        },
        description: {
            fontSize: 14,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            '-webkit-line-clamp': 2, /* number of lines to show */
            '-webkit-box-orient': 'vertical',
        },
        rating: {
            color: AppColor.mainColor
        },
        availability: {
            backgroundColor: 'rgba(196, 196, 196, 0.12)',
            boxSizing: 'border-box',
            borderRadius: '15px',
            display: 'flex',
            width: 'fit-content'
        },
        dayOfWeeks: {
            border: '2px solid white',
            backgroundColor: 'rgba(196, 196, 196, 0.12)',
            boxSizing: 'border-box',
        },
        innerBox2: {
            borderRight: '2px solid white',
            borderBottom: '2px solid white',
            boxSizing: 'border-box'
        },
        innerBox3: {
            borderRight: '2px solid white',
            boxSizing: 'border-box'
        },
        titleDay: {
            fontSize: below959 ? '7px' : '9px',
            fontWeight: '600',
            color: '#fff',
            textAlign: 'center'
        },
        boxTitle: {
            backgroundColor: AppColor.mainColor,
            color: '#fff'
        },
        titleDay2: {
            fontSize: below959 ? '7px' : '9px',
            fontWeight: '600',
            color: '#fff',
            textAlign: 'center',
            marginTop: '3px'
        },
        date: {
            fontSize: '12px',
            color: 'rgba(0,0,0,0.7)',
            fontWeight: 'normal',
            textAlign: 'center',
            marginTop: 5
        },
        free: {
            color: '#00b100'
        },
        busy: {
            color: '#fe6359'
        },
        noMaxWidth: {
            '& .MuiGrid-grid-xs-10': {
                maxWidth: 0
            }
        },
        hyperLink: {
            color: AppColor.blue,
            textDecoration: 'underline'
        }
    }))
    const classes = useStyles();
    useEffect(() => {
        accreditationList && setAccreditations(accreditationList)
    }, [accreditationList]);


    const getThisWeekDates = () => {
        var weekDates = [];

        for (var i = 1; i <= 7; i++) {
            weekDates.push(moment().day(i));
        }

        return weekDates;
    }

    var thisWeekDates = getThisWeekDates();

    const renderEmptySchedulesWorkers = () => {
        let scheduleWorker = [];
        thisWeekDates.forEach(date => {
            scheduleWorker.push({
                date: date.format("DD/MM/YYYY"),
                dayOfWeek: t(`daysOfWeek.${date.day()}`),
                isFreeTime: false
            });
        });
        return (
            <>
                <Grid item xs={1.5}>
                    <Box style={{ backgroundColor: 'rgba(196, 196, 196, 0.12)' }}
                        display="grid" justifyContent="space-between" alignItems="center"
                    >
                        <Box
                            className={classes.boxTitle}
                            p={2} style={{ width: '100%', borderBottom: '2px solid white', borderRight: '2px solid white', height: 30 }}
                            display="grid" justifyContent="center" alignItems="center"
                        >
                            <Typography variant="h5" className={classes.titleDay}>
                            </Typography>
                        </Box>
                        <Box
                            className={classes.boxTitle}
                            p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                            display="flex" justifyContent="center" alignItems="center"
                        >
                            <Typography variant="h5" className={classes.titleDay}>
                                {t("label.morning")}
                            </Typography>
                        </Box>
                        <Box
                            className={classes.boxTitle}
                            p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                            display="flex" justifyContent="center" alignItems="center"
                        >
                            <Typography variant="h5" className={classes.titleDay}>
                                {t("label.afternoon")}
                            </Typography>
                        </Box>
                        <Box
                            className={classes.boxTitle}
                            p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                            display="flex" justifyContent="center" alignItems="center"
                        >
                            <Typography variant="h5" className={classes.titleDay}>
                                {t("label.evening")}
                            </Typography>
                        </Box>
                        <Box
                            className={classes.boxTitle}
                            p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                            display="flex" justifyContent="center" alignItems="center"
                        >
                            <Typography variant="h5" className={classes.titleDay}>
                                {t("label.night")}
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                {scheduleWorker.map((data, index) => (
                    <Grid item xs={1.5} key={index}>
                        <Box style={{ backgroundColor: 'rgba(196, 196, 196, 0.12)' }}
                            display="grid" justifyContent="space-between" alignItems="center"
                        >
                            <Box
                                className={classes.boxTitle}
                                p={2} style={{ width: '100%', borderBottom: '2px solid white', borderRight: '2px solid white', height: 30 }}
                                display="flex" justifyContent="center" alignItems="center" flexDirection="column"
                            >
                                <Typography variant="h5" className={classes.titleDay}>
                                    {data.dayOfWeek}
                                </Typography>
                                <Typography variant="h5" className={classes.titleDay2}>
                                    {data.date}
                                </Typography>
                            </Box>
                            <Box
                                p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                                display="flex" justifyContent="center" alignItems="center"
                            >
                                <Typography variant="h5" className={classes.date}>
                                    {data.isFreeTime ? <DoneIcon className={classes.free} /> : <CloseIcon className={classes.busy} />}
                                </Typography>
                            </Box>
                            <Box
                                p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                                display="flex" justifyContent="center" alignItems="center"
                            >
                                <Typography variant="h5" className={classes.date}>
                                    {data.isFreeTime ? <DoneIcon className={classes.free} /> : <CloseIcon className={classes.busy} />}
                                </Typography>
                            </Box>
                            <Box
                                p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                                display="flex" justifyContent="center" alignItems="center"
                            >
                                <Typography variant="h5" className={classes.date}>
                                    {data.isFreeTime ? <DoneIcon className={classes.free} /> : <CloseIcon className={classes.busy} />}
                                </Typography>
                            </Box>
                            <Box
                                p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                                display="flex" justifyContent="center" alignItems="center"
                            >
                                <Typography variant="h5" className={classes.date}>
                                    {data.isFreeTime ? <DoneIcon className={classes.free} /> : <CloseIcon className={classes.busy} />}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}</>
        )
    }

    // const headCells = [
    //     {
    //         id: "dayShift",
    //         numeric: "left",
    //         disablePadding: false,
    //         label: "",
    //         sort: false,
    //     },
    //     {
    //         id: "monday",
    //         numeric: "left",
    //         disablePadding: false,
    //         label: "days.monday",
    //         sort: false,
    //     },
    //     {
    //         id: "tuesday",
    //         numeric: "left",
    //         disablePadding: false,
    //         label: "days.tuesday",
    //         sort: false,
    //     },
    //     {
    //         id: "wednesday",
    //         numeric: "left",
    //         disablePadding: false,
    //         label: "days.wednesday",
    //         sort: false,
    //     },
    //     {
    //         id: "thursday",
    //         numeric: "left",
    //         disablePadding: false,
    //         label: "days.thursday",
    //         sort: false,
    //     },
    //     {
    //         id: "friday",
    //         numeric: "left",
    //         disablePadding: false,
    //         label: "days.friday",
    //         sort: false,
    //     },
    //     {
    //         id: "saturday",
    //         numeric: "left",
    //         disablePadding: false,
    //         label: "days.saturday",
    //         sort: false,
    //     },
    //     {
    //         id: "sunday",
    //         numeric: "left",
    //         disablePadding: false,
    //         label: "days.sunday",
    //         sort: false,
    //     },
    // ];

    const renderScheduleWorkerMobile = (data) => {
        return (
            <React.Fragment>
                <Grid container spacing={1}>
                    <Grid item xs={1.5} style={{ minWidth: 37 }}>
                        <Paper className={classes.paper}></Paper>
                    </Grid>
                    <Grid item xs={1.5} style={{ minWidth: 37 }} >
                    <Paper className={classes.paper}style={{ textAlign: 'center'}}><p>Mon</p></Paper>
                    </Grid>
                    <Grid item xs={1.5} style={{ minWidth: 37 }}>
                    <Paper className={classes.paper}style={{ textAlign: 'center'}}><p>Tue</p></Paper>
                    </Grid>
                    <Grid item xs={1.5} style={{ minWidth: 37 }}>
                    <Paper className={classes.paper}style={{ textAlign: 'center'}}><p>Wed</p></Paper>
                    </Grid>
                    <Grid item xs={1.5} style={{ minWidth: 37 }}>
                    <Paper className={classes.paper}style={{ textAlign: 'center'}}><p>Thu</p></Paper>
                    </Grid>
                    <Grid item xs={1.5} style={{ minWidth: 37 }}>
                        <Paper className={classes.paper} style={{ textAlign: 'center'}}><p>Fri</p></Paper>
                    </Grid>
                    <Grid item xs={1.5} style={{ minWidth: 37 }}>
                        <Paper className={classes.paper}style={{ textAlign: 'center'}}><p>Sat</p></Paper>
                    </Grid>
                    <Grid item xs={1.5} style={{ minWidth: 37 }}>
                        <Paper className={classes.paper}style={{ textAlign: 'center'}}><p>Sun</p></Paper>
                    </Grid>
                </Grid>
                
                <Grid container alignItems='flex-start' spacing={1}>
                    <Grid item xs={1.5}>
                    <Grid container direction='column' alignItems='flex-start' spacing={1} >
                    <Grid item  xs={1.5}>
                        <Paper className={classes.paper}>DST</Paper>
                    </Grid>
                    <Grid item  xs={1.5}>
                        <Paper className={classes.paper}>NGT</Paper>
                    </Grid>
                    <Grid item  xs={1.5}>
                        <Paper className={classes.paper}>ACT</Paper>
                    </Grid>
                    <Grid item  xs={1.5}>
                        <Paper className={classes.paper}>SLO</Paper>
                    </Grid>
                </Grid>
                    </Grid>
                    {data.map((item, index) => {
                        return (
                            <Grid item xs={1.5} key={index}>
                                <Grid container direction='column' spacing={1}>
                                    {item.shifts.map((shift) => {
                                        return (
                                        <Grid item xs={1.5} key={shift.id} style={{ minWidth: 37, marginLeft: index === 1 ? 2 : index === 3 ? 5 : 0}}>
                                            <Paper >{shift.isFreeTime ? <DoneIcon className={classes.free} /> : <CloseIcon className={classes.busy} />}</Paper>
                                        </Grid>
                                    )
                                    })}
                                </Grid>

                            </Grid>
                        )
                    })}
                </Grid>
            </React.Fragment>
        )
    };

    return (
        <Box mt={3}>
            <Box my={3}>
                {!!address && (
                    <Typography
                        className={classes.resultTitle}
                        dangerouslySetInnerHTML={{
                            __html: t('text.show_search_result', {
                                total: `<strong>${totalElements}</strong>`,
                                address: `<strong>${address}</strong>`
                            })
                        }}
                    >
                    </Typography>
                )}
            </Box>
            {data.map((worker, index) => {
                let accreditation = accreditations.find(acc => acc.id === worker.accreditationId);
                return (
                    (
                        <Box key={`${worker.id} ${index}`} my={3} py={3} className={classes.container}>
                            {!isMobile && <Grid container spacing={2}>
                                <Grid item sm={12} md={2}>
                                    <Box display="flex" justifyContent="center">
                                        {worker.avatarAws3Link ? (
                                            <img src={worker.avatarAws3Link} className={classes.image} alt="Avatar" />
                                        ) : (
                                            <Avatar style={{ width: '140px', height: '140px' }} />
                                        )}
                                    </Box>
                                </Grid>
                                <Grid item sm={12} md={8}>
                                    <Typography variant="h5" className={classes.title}>
                                        {worker.firstName} {worker.lastName}
                                    </Typography>
                                    <Link to={`/admin/search-worker/detail/${worker.id}`} style={{ width: 'fit-content' }}>
                                        <AppButton
                                            label={t('label.view_profile')}
                                            buttonColor={AppColor.pink}
                                        />
                                    </Link>
                                    <Box mt={4}>
                                        {accreditation && (
                                            <Typography variant="body1" className={classes.specialty}>
                                                {accreditation.name}
                                            </Typography>
                                        )}
                                        <Typography variant="body1" className={classes.specialty} noWrap>
                                            {
                                                worker.workerType === WORKER_TYPE.NURSE
                                                    ? worker.specialties && worker.specialties.map(sp => sp.name).join(', ')
                                                    : worker.supports && worker.supports.map(sp => sp.name).join(', ')
                                            }
                                        </Typography>
                                    </Box>
                                    <Box mt={3}>
                                        <Typography variant="body1" className={classes.description}>
                                            {worker.description}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <Box display="grid" className="h-100 text-right">
                                        <Box>
                                            <Rating
                                                name="read-only"
                                                value={worker.rating}
                                                precision={0.5}
                                                readOnly
                                                className={classes.rating}
                                            />
                                            <Typography>
                                                {t('label.point_value', {
                                                    value: worker.point
                                                })}
                                            </Typography>
                                        </Box>
                                        <Box mt={'auto'}>
                                            <Typography>
                                                <i className="fas fa-map-marker-alt mr-2" />
                                                {t('label.km_away', {
                                                    km: worker.distance ? (worker.distance / 1000).toFixed(2) : worker.distance
                                                })}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item sm={12} md={12}>
                                    <Grid container spacing={0} justifyContent='center'>
                                        {!below959 && <Grid item xs={2}></Grid>}
                                        <Grid item xs={below959 ? 12 : 9}>
                                            <Grid container spacing={0}>
                                                {worker.schedulesWorker.length === 0 && renderEmptySchedulesWorkers()}
                                                {worker.schedulesWorker && worker.schedulesWorker.length > 0 && <Grid item xs={1.5}>
                                                    <Box style={{ backgroundColor: 'rgba(196, 196, 196, 0.12)' }}
                                                        display="grid" justifyContent="space-between" alignItems="center"
                                                    >
                                                        <Box
                                                            className={classes.boxTitle}
                                                            p={2} style={{ width: '100%', borderBottom: '2px solid white', borderRight: '2px solid white', height: 30 }}
                                                            display="grid" justifyContent="center" alignItems="center"
                                                        >
                                                            <Typography variant="h5" className={classes.titleDay}>
                                                            </Typography>
                                                        </Box>
                                                        <Box
                                                            className={classes.boxTitle}
                                                            p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                                                            display="flex" justifyContent="center" alignItems="center"
                                                        >
                                                            <Typography variant="h5" className={classes.titleDay}>
                                                                {t("label.morning")}
                                                            </Typography>
                                                        </Box>
                                                        <Box
                                                            className={classes.boxTitle}
                                                            p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                                                            display="flex" justifyContent="center" alignItems="center"
                                                        >
                                                            <Typography variant="h5" className={classes.titleDay}>
                                                                {t("label.afternoon")}
                                                            </Typography>
                                                        </Box>
                                                        <Box
                                                            className={classes.boxTitle}
                                                            p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                                                            display="flex" justifyContent="center" alignItems="center"
                                                        >
                                                            <Typography variant="h5" className={classes.titleDay}>
                                                                {t("label.evening")}
                                                            </Typography>
                                                        </Box>
                                                        <Box
                                                            className={classes.boxTitle}
                                                            p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                                                            display="flex" justifyContent="center" alignItems="center"
                                                        >
                                                            <Typography variant="h5" className={classes.titleDay}>
                                                                {t("label.night")}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Grid>}
                                                {worker.schedulesWorker && worker.schedulesWorker.map((data, index) => (
                                                    <Grid item xs={1.5} key={`${data.date}-${index}`}>
                                                        <Box style={{ backgroundColor: 'rgba(196, 196, 196, 0.12)' }}
                                                            display="grid" justifyContent="space-between" alignItems="center"
                                                        >
                                                            <Box
                                                                className={classes.boxTitle}
                                                                p={2} style={{ width: '100%', borderBottom: '2px solid white', borderRight: '2px solid white', height: 30 }}
                                                                display="flex" justifyContent="center" alignItems="center" flexDirection="column"
                                                            >
                                                                <Typography variant="h5" className={classes.titleDay}>
                                                                    {t(`daysOfWeek.${moment(data.date).day()}`)}
                                                                </Typography>
                                                                <Typography variant="h5" className={classes.titleDay2}>
                                                                    {moment(data.date).format("DD/MM/YYYY")}
                                                                </Typography>
                                                            </Box>
                                                            {data.shifts.map((item, index) => (
                                                                <Box
                                                                    key={`${item.id ? item.id : item.workerId} ${index}`}
                                                                    p={2} style={{ width: '100%', borderRight: '2px solid white', height: 30 }}
                                                                    display="flex" justifyContent="center" alignItems="center"
                                                                >
                                                                    <Typography variant="h5" className={classes.date}>
                                                                        {item.isFreeTime ? <DoneIcon className={classes.free} /> : <CloseIcon className={classes.busy} />}
                                                                    </Typography>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                        {!below959 && <Grid item xs></Grid>}
                                    </Grid>

                                </Grid>
                            </Grid>}
                            {isMobile && <Grid container spacing={2}>
                                <Grid item sm={12} md={2} xs={12}>
                                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                                        <Typography variant="h2" className={classes.titleMobile}>
                                            {worker.avatarAws3Link ? (
                                                <img src={worker.avatarAws3Link} className={classes.imageMobile} alt="Avatar" />
                                            ) : (
                                                <Avatar style={{ width: '100px', height: '100px' }} />
                                            )}
                                            <Link to={`/admin/search-worker/detail/${worker.id}`}
                                                style={{
                                                    width: '100%',
                                                    textAlign: 'center',
                                                    marginTop: 10,
                                                    color: AppColor.blue,
                                                    textDecoration: 'underline'
                                                }}
                                            >
                                                {worker.firstName} {worker.lastName}
                                            </Link>
                                            <Box>
                                                <Rating
                                                    name="read-only"
                                                    value={worker.rating}
                                                    precision={0.5}
                                                    readOnly
                                                    className={classes.rating}
                                                />
                                                <Typography>
                                                    {t('label.point_value', {
                                                        value: worker.point
                                                    })}
                                                </Typography>
                                            </Box>
                                            <Box mt={'auto'}>
                                                <Typography>
                                                    <i className="fas fa-map-marker-alt mr-2" />
                                                    {t('label.km_away', {
                                                        km: worker.distance ? (worker.distance / 1000).toFixed(2) : worker.distance
                                                    })}
                                                </Typography>
                                            </Box>
                                        </Typography>
                                        <Box>
                                            {accreditation && (
                                                <Typography variant="body1" mt={1} className={classes.specialty}>
                                                    {accreditation.name}
                                                </Typography>
                                            )}
                                            <Typography variant="body1" mt={1} className={classes.specialty} noWrap>
                                                {
                                                    worker.workerType === WORKER_TYPE.NURSE
                                                        ? worker.specialties && worker.specialties.map(sp => sp.name).join(', ')
                                                        : worker.supports && worker.supports.map(sp => sp.name).join(', ')
                                                }
                                            </Typography>
                                        </Box>
                                        <Box mt={1}>
                                            <Typography variant="body1" className={classes.description}>
                                                {worker.description}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item sm={12} md={8} sx={12} noWrap style={{ width: '100%' }}>

                                    {renderScheduleWorkerMobile(worker.schedulesWorker)}

                                </Grid>
                            </Grid>}
                        </Box>
                    )
                )
            })}
        </Box>
    )
}

SearchList.propTypes = {
    totalElements: PropTypes.number,
    address: PropTypes.string,
    data: PropTypes.array
}

export default SearchList;
